import { configureStore } from "@reduxjs/toolkit";
import { coreApiSlice } from "account-app/core-api-slice";

export const rootReducer = {
  [coreApiSlice.reducerPath]: coreApiSlice.reducer
};

export default configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(coreApiSlice.middleware)
});
